<template>
  <div>
    <header>
      <div class="d1-header">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 head-st">
              <div class="logo">
                <img class="img-responsive" src="@/assets/images/iconlogo.png" alt="logo" />
                <span>
                  <button type="button" class="btn btn-light mode-d2">
                    <router-link to="/projects">
                      <img class="plus-img" src="@/assets/images/play.png" alt="logo" />
                      {{$t('projects')}}
                    </router-link>
                  </button>
                </span>
              </div>
              <div class="title-head1">{{projectName}}</div>
              <div class="user-icon1">
                <span class="setting-icon">
                  <img class="img-responsive" src="@/assets/images/setting.png" style="cursor: pointer" alt="user" @click="$router.push('/setting')" />
                </span>
                <span>
                  <img class="img-responsive" src="@/assets/images/user.png" alt="user" />
                </span>

                <span class="u-txt">{{ authUser.firstname }} {{ authUser.lastname }}</span>
                <span class="u-dp">
                  <div class="dropdown show">
                    <img class="img-responsive dropdown-toggle arrow-img"
                      src="@/assets/images/dropdown.png"
                      alt="user"
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"/>

                    <div class="dropdown-menu dropdown-menu-right dp-box" aria-labelledby="dropdownMenuLink">
                      <a class="dropdown-item"
                        data-toggle="modal"
                        data-target="#exampleModalCenter"
                        href="#"
                        @click="emptyModal">

                        <img class="img-responsive" src="@/assets/images/Shape.png" alt="shapw" />
                        <span>{{$t('profile_edit')}}</span>
                      </a>
                      <a
                        class="dropdown-item"
                        data-toggle="modal"
                        data-target="#exampleModalCenter2"
                        href="#"
                      >
                        <img class="img-responsive" src="@/assets/images/Shape1.png" alt="shapw" />
                        <span>{{$t('language')}}</span>
                      </a>
<!--                      <a class="dropdown-item" href="#">-->
<!--                        <img class="img-responsive" src="@/assets/images/Shape2.png" alt="shapw" />-->
<!--                        <span>{{$t('customer_administration')}}</span>-->
<!--                      </a>-->
                      <a class="dropdown-item" href="#" @click="logout()">
                        <img class="img-responsive" src="@/assets/images/Shape3.png" alt="shapw" />
                        <span>{{$t('logout')}}</span>
                      </a>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="main-content2">
              <div class="conatiner-fluid">
                <div class="head1" id="head1">
<!--                  <div onclick="openTab('DataMA')" class="head-title1">{{$t('overview')}}</div>-->
                  <div class="head-title1">{{$t('photos')}}</div>
                  <div onclick="openTab('DataMB')" class="head-title1 active1">{{$t('plans')}}</div>
                  <div class="head-title1">{{$t('documentation')}}</div>
                  <div class="head-title1">{{$t('flaw')}}</div>
                  <div class="head-title1" v-if="$config.modules.tickets">{{$t('tickets')}}</div>
<!--                  <div class="head-title1">{{$t('dms')}}</div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--Navbar-->
      <div class="m1-header">
        <nav class="navbar navbar-light light-blue lighten-4">
          <!-- Navbar brand -->
          <a class="navbar-brand logo" href="#">
            <img class="img-responsive" src="@/assets/images/Logo.png" alt="logo" />
          </a>

          <!-- Collapse button -->
          <button
            class="navbar-toggler toggler-example"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent1"
            aria-controls="navbarSupportedContent1"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="dark-blue-text">
              <i class="fa fa-bars fa-1x"></i>
            </span>
          </button>

          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent1">
            <!-- Links -->
            <ul class="navbar-nav mr-auto">
<!--              <li class="nav-item" onclick="openTab('DataMA')">-->
<!--                <a class="nav-link" href="#">{{$t('overview')}}</a>-->
<!--              </li>-->
              <li class="nav-item">
                <a class="nav-link" href="#">{{$t('photos')}}</a>
              </li>
              <li class="nav-item active">
                <a class="nav-link" href="#" onclick="openTab('DataMB')">{{$t('plans')}}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">{{$t('documentation')}}</a>
              </li>
              <li class="nav-item">
                <a class="nav-link"  href="#">{{$t('flaw')}}</a>
              </li>
<!--              <li class="nav-item">-->
<!--                <a class="nav-link" href="#">{{$t('dms')}}</a>-->
<!--              </li>-->
              <li
                class="nav-item"
                data-toggle="collapse"
                data-target="#navbarSupportedContent2"
                aria-controls="navbarSupportedContent2"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <a class="nav-link" href="#">
                  <img class="img-responsive" src="@/assets/images/setting.png" alt="user" />
                  <img class="img-responsive" src="@/assets/images/user.png" alt="user" />
                  <span class="u-txt">Stuart Heller</span>
                  <span class="u-dp">
                    <img class="img-responsive arrow-img" src="@/assets/images/dropdown.png" />
                  </span>
                </a>
              </li>
              <div class="collapse navbar-collapse2" id="navbarSupportedContent2">
                <!-- Links -->
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item" data-toggle="modal" data-target="#exampleModalCenter">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="assets/images/Shape.png" alt="shapw" />
                      <span>{{$t('edit_profile')}}</span>
                    </a>
                  </li>
                  <li class="nav-item" data-toggle="modal" data-target="#exampleModalCenter2">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="assets/images/Shape1.png" alt="shapw" />
                      <span>{{$t('language')}} ({{$t('german')}})</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="assets/images/Shape2.png" alt="shapw" />
                      <span>{{$t('customer_administration')}}</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">
                      <img class="img-responsive" src="assets/images/Shape3.png" alt="shapw"/>
                      <span>{{$t('sign_out')}}</span>
                    </a>
                  </li>
                </ul>
                <!-- Links -->
              </div>
            </ul>
            <!-- Links -->
          </div>
          <!-- Collapsible content -->
        </nav>
      </div>
      <!--/.Navbar-->
      <!-- Modal 1-->
      <div
        class="modal fade"
        id="exampleModalCenter"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div class="response-alert">
          <div class="alert alert-success alert-dismissible" v-for="m in modal3">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <strong></strong>
            {{m}}
          </div>
          <div class="alert alert-danger alert-dismissible" v-for="e in emodal3">
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <strong></strong>
            {{e}}
          </div>
        </div>
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="spinner-cover" :class="{'d-block' : isLoading}" style="display: block;">
            <div class="spinner"></div>
          </div>
          <div class="modal-content">
            <form @submit.prevent="updateProfile()" class="form-border-none" >
              <div class="modal-body">
                <div class="row row-data">
                  <div class="col-12 pro-style">{{ $t("profile_edit")}}</div>
                  <div class="col-lg-1 col-md-1 col-sm-1 col-1st">
                    <img class src="@/assets/images/user.png" alt="user" />
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-2nd">
                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label
                          class="form-label"
                        >{{ $t("email")}} {{ $t("address")}} ({{ $t("user_name")}}) *</label>
                        <div class="input-group">
                          <input
                            readonly
                            class="input--style-2"
                            type="text"
                            placeholder="Max.mustermann@web.de"
                            v-model="user.email"
                            @blur="$v.user.email.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.email.$error }"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.email.email || (submitted && !$v.user.email.required)"
                          class="text-danger"
                        >{{ $t('email') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("salutation")}} *</label>
                        <select
                          class="custom-select cus-select custom-select-sm mb-3 mt-1 select-box"
                          v-model="user.gender"
                          @blur="$v.user.gender.$touch()"
                          :class="{ 'is-invalid': submitted && $v.user.gender.$error }"
                        >
                          <option value selected>{{$t("select")}}</option>
                          <option value="0">{{$t("mr")}}</option>

                          <option value="1">{{$t("mrs")}}</option>
                        </select>
                        <div
                          v-if="submitted && !$v.user.gender.required"
                          class="text-danger"
                        >{{ $t('salutation') }} {{ $t('is_required') }}</div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("title")}} *</label>
                        <div class="input-group">
                          <input
                            class="input--style-2"
                            type="text"
                            v-model="user.title"
                            @blur="$v.user.title.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.title.$error }"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.title.required"
                          class="text-danger"
                        >{{ $t('title') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("first_name")}} *</label>
                        <div class="input-group">
                          <input
                            class="input--style-2"
                            type="text"
                            placeholder="Carsten"
                            name="name"
                            v-model="user.firstname"
                            @blur="$v.user.firstname.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.firstname.$error }"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.firstname.required"
                          class="text-danger"
                        >{{ $t('first_name') }} {{ $t('is_required') }}</div>
                      </div>

                      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label class="form-label">{{ $t("last_name")}} *</label>
                        <div class="input-group">
                          <input
                            class="input--style-2"
                            type="text"
                            placeholder="Brand"
                            name="name"
                            v-model="user.lastname"
                            @blur="$v.user.lastname.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.lastname.$error }"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.lastname.required"
                          class="text-danger"
                        >{{ $t('last_name') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <label class="form-label">{{ $t("company")}} *</label>
                        <div class="input-group">
                          <input
                            @blur="$v.user.company.$touch()"
                            :class="{ 'is-invalid': submitted && $v.user.company.$error }"
                            class="input--style-2"
                            type="text"
                            placeholder="Müller GmbH"
                            name="name"
                            v-model="user.company"
                          />
                        </div>
                        <div
                          v-if="submitted && !$v.user.company.required"
                          class="text-danger"
                        >{{ $t('company') }} {{ $t('is_required') }}</div>
                      </div>
                    </div>

                  </div>
                  <div class="col-lg-3 col-md-3 col-sm-3 col-3rd" style="display:none;">
                  <span style="font-weight: 500">
                    <img class src="@/assets/images/Group.png" alt="user" />
                    &nbsp;&nbsp; {{ $t("passwordc") }}
                  </span>
                    <div class="group-txt">{{ $t("change_account_password") }}</div>
                    <div v-if="passwordChange">
                      <div class="sm-form">
                        <form @submit.prevent="updatePassword()" class="needs-validation" novalidate>
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class="form-label1">{{ $t('current_password') }} *</label>
                              <div class="input-group inp">
                                <input
                                  class="input--style-2 form-control"
                                  type="password"
                                  placeholder="Aktuelles Kennwort"
                                  name="name"
                                  v-model="currentpassword"
                                  @blur="$v.currentpassword.$touch()"
                                  :class="{ 'is-invalid':submitted1 && $v.currentpassword.$error }"
                                />
                                <!--<div v-if="!$v.currentpassword.required" class="invalid-feedback">
                                  {{ $t('current_password') }} {{ $t('is_required') }}
                                </div>-->
                                <div class="valid-feedback"></div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class="form-label1">{{ $t('new_password') }} *</label>
                              <div class="input-group inp">
                                <input
                                  class="input--style-2 form-control"
                                  type="password"
                                  placeholder="Neues Kennwort"
                                  name="name"
                                  v-model="password"
                                  @blur="$v.password.$touch()"
                                  :class="{ 'is-invalid':submitted1 && $v.password.$error }"
                                />
                                <!--<div v-if="!$v.currentpassword.required" class="invalid-feedback">
                                        {{ $t('current_password') }} {{ $t('is_required') }}
                                </div>-->
                                <div
                                  v-if="$v.password.required && !$v.password.minLen"
                                  class="invalid-feedback"
                                >{{ $t('password') }} {{ $t('must_be_at_least') }} {{$v.password.$params.minLen.min}} {{ $t('characters') }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                              <label class="form-label1">{{ $t('confirm_password') }} *</label>
                              <div class="input-group inp">
                                <input
                                  class="input--style-2 form-control"
                                  type="password"
                                  placeholder="Neues Kennwort bestätigen"
                                  name="name"
                                  v-model="repeatpassword"
                                  @blur="$v.password.$touch()"
                                  :class="{ 'is-invalid':submitted1 && $v.repeatpassword.$error }"
                                />

                                <div
                                  v-if="$v.repeatpassword.$error"
                                  class="invalid-feedback"
                                >{{ $t('password') }} {{ $t('not_matched') }}</div>
                              </div>
                            </div>
                          </div>

                          <div class="p-t-30">
                            <!-- <button class="btn btn-sf btn--radius btn--green" type="submit">save</button>
                          <button
                      type="button"
                      @click="passwordChange=!passwordChange"
                      class="btn btn-sf btn--radius btn--green"
                            >{{ $t("hide") }}</button>-->
                          </div>
                        </form>
                      </div>
                    </div>
                    <button
                      type="button"
                      v-if="!passwordChange"
                      @click="passwordChange='false'"
                      class="btn btn-light btn-sm btn-small"
                    >{{ $t("change") }}</button>
                  </div>
                </div>
              </div>
              <div class="modal-footer mf-1st">
                <button
                  type="button"
                  class="btn mode-d"
                  data-dismiss="modal"
                >{{ $t("cancel")}}</button>
                <button type="submit" class="btn btn-primary mode-s">{{ $t("save")}}</button>
                <div class="cross-close" data-dismiss="modal">
                  <img src="@/assets/images/cross.png" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="modal fade" id="exampleModalCenter2" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <form @submit.prevent="changeLang()">
              <div class="modal-body">
                <div class="row row-data">
                  <div class="col-12 pro-style2">{{$t("set_the_language")}}</div>

                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="custom-control custom-radio cus-radio">
                      <input
                        type="radio"
                        class="custom-control-input"
                        id="customRadio"
                        value="de"
                        v-model="lang"/>
                      <label class="custom-control-label" for="customRadio">
                        <span class="img-flag">
                          <img class="img-responsive" src="@/assets/images/germany.png" alt="user" />
                        </span>
                        <span class="language">Deutsch</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer mf-1st">
                <button
                  type="button"
                  class="btn btn-light mode-d"
                  data-dismiss="modal">{{ $t("cancel") }}</button>
                <button type="submit" class="btn btn-primary mode-s">{{ $t("save") }}</button>
                <div class="cross-close" data-dismiss="modal">
                  <img src="@/assets/images/cross.png" />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="spinner-cover" style="display: block;">
        <div class="spinner"></div>
      </div>
    </header>
  </div>
</template>
<script>
import axios from '../../utils/axiosinstance'
// import axios from 'axios'

import {
  required,
  email,
  minLength,
  numeric,
  sameAs
} from 'vuelidate/lib/validators'
export default {
  name: 'Main_Header',
  data () {
    return {
      projectName: '',
      submitted: false,
      nameShowInheader: '',
      submitted1: true,
      passwordChange: false,
      lang: this.$i18n.locale,
      currentpassword: '',
      password: '',
      repeatpassword: '',

      user: {
        pduserid: '',
        email: '',
        created: '',
        lastlogin: '',
        status: '',
        gender: '',
        title: '',
        firstname: '',
        lastname: '',
        company: '',
        street: '',
        zipcode: '',
        city: '',
        country: '',
        description: '',
        language: '',
        emailinfo: null,
        telefon: ''
      },
      modal3: [],
      emodal3: [],
      tabA: 1,
      tabC: 0,
      tabB: 0,
      search: ''
    }
  },
  created () {
    // this.changeLang();
    // $(".spinner-cover").css("display", "none");
    // $(".spinner-cover").hide();
    if (this.authUser.pduserid){
      this.getrecord()
    }

    this.getProject()
  },
  validations () {
    if (this.passwordChange) {
      return {
        currentpassword: { required },
        password: { required, minLen: minLength(6) },
        repeatpassword: { required, sameAs: sameAs('password') },
        user: {
          firstname: { required },
          email: { required, email },
          lastname: { required },
          company: { required },
          gender: { required },
          title: { required },
          telefon: { numeric }
        }
      }
    } else {
      return {
        user: {
          firstname: { required },
          email: { required, email },
          lastname: { required },
          company: { required },
          title: { required },
          gender: { required },
          telefon: { numeric }
        }
      }
    }
  },
  beforeCreate () {
    // localStorage.apikey='5b9ccf76e45cba2867816580aa5b13b3';
    if (!localStorage.apikey) this.$router.push('/login')
  },
  computed: {
    isLoading(){
      return this.$store.state.appSettings.isLoading()
    },
    authUser(){
      return this.$store.state.project.user
    }
  },

  methods: {
    getProject () {
      let pp = this.$store.state.projects.projects
      let _this = this
      pp.forEach(function myFunction (pro) {
        if (pro.id === _this.$route.params.id) { _this.projectName = pro.projectname }
      })
    },
    changeLang () {
      this.$i18n.locale = this.lang
      localStorage.locale = this.lang
      $('#exampleModalCenter2').modal('hide')
    },

    getrecord () {
      var params = new URLSearchParams()
      axios.post(process.env.VUE_APP_BASE_URL + `user/getprofile`, params, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: 'string',
          accept: 'application/json'
        }
      }).then(response => {
        this.user = response.data.data.user
        localStorage.user = response.data.data.user
        this.$store.commit('setAuthUser',response.data.data.user)
        this.nameShowInheader =
          response.data.data.user.firstname +''+
          response.data.data.user.lastname
      })
        .catch(e => {
          localStorage.clear()
          this.$router.push('/login')
        })
    },

    async logout () {
      localStorage.apikey = null;
      await this.$store.dispatch('logout');
      await this.$router.push('/login')
    },

    updateProfile () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      if (this.passwordChange) {
        this.user.password = this.password
        this.user.password_rpt = this.repeatpassword
      }
      $('.spinner-cover').show()

      var params = new URLSearchParams()
      // params.append("api_token", localStorage.token);
      axios.post(process.env.VUE_APP_BASE_URL + `user/saveprofile`,
        JSON.stringify(this.user),
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string',
            accept: 'application/json'
          }
        }
      )
        .then(response => {
          if (response.status == 200) {
            this.modal3.push(response.statusText)
            // $("#exampleModalCenter").modal("hide");
          }
          $('.spinner-cover').hide()
        })
        .catch(e => {
          $('.spinner-cover').hide()
          this.emodal3.push(e)
          console.log(e)

          // this.errors.push(e);
        })
    },
    updatePassword () {
      this.submitted1 = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }

      var params = new URLSearchParams()
      // params.append("api_token", localStorage.token);
    },
    emptyModal () {
      this.modal3 = []
      this.emodal3 = []
      this.passwordChange = false
    },
    openTab (dataName) {
      this.tabA = this.tabB = this.tabC = 0
      if (dataName == 'DataA') this.tabA = 1
      if (dataName == 'DataB') this.tabB = 1
      if (dataName == 'DataC') this.tabC = 1
      let i
      let x = document.getElementsByClassName('d1')
      for (i = 0; i < x.length; i++) {
        x[i].style.display = 'none'
      }
      document.getElementById(dataName).style.display = 'block'
    }
  },
  watch: {
    modal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    msg: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    emodal3: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    },
    error: function (val) {
      setTimeout(function () {
        $('.alert').alert('close')
      }, 2000)
    }
  }
}
</script>
<style scoped>
.d-block{
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/Header.vue